module.exports = __webpack_public_path__ + "static/img/join.3e65a13.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/join.jpg
// module id = clRT
// module chunks = 1